import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12.974 0C14.093 0 15 .907 15 2.026V7h4.611a2 2 0 011.97 2.352l-1.755 9.819a2 2 0 01-2.174 1.638L6.794 19.686A2 2 0 015 17.696V8a7.076 7.076 0 005.932-4.795l.76-2.281A1.35 1.35 0 0112.974 0zM2.4 19.2H1.2v-12h1.2v12z" fill="#000" /></svg>;